// Third-party
import React from 'react';

// Components
import { FormattedMessage } from '../../../../../utils/i18n';
import ColorSwatcher from '@/views/components/misc/ColorSwatcher';
import { Typography } from '@capintel/component-lib/typography';

// Utils
import * as ProposalNS from '../../../Proposal';
import { getProposalCoBrandingColor } from '@/modules/proposal/ProposalHelpers';

// Types
import User from '@/types/user';
import { ALLOWED_HTML_TAGS } from '@/views/components/i18n/FormattedMessageV2';

type Props = {
  onUpdateCoBrandedColors: (pattern: string, key: string) => void;
  styleOptions: ProposalNS.ProposalStyleOptionsV2;
  user: User;
};

const ProposalCoBrandingColors: React.FunctionComponent<Props> = ({ onUpdateCoBrandedColors, styleOptions, user }: Props) => {
  if (!styleOptions) {
    return null;
  }

  const onUpdatePrimaryColor = (pattern: string) => {
    onUpdateCoBrandedColors(pattern, 'primary');
  };

  const selectedColor = getProposalCoBrandingColor(user, styleOptions);

  return (
    <div className="proposal-option">
      <Typography as={ALLOWED_HTML_TAGS.H2} color="primary" variant="headerXs">
        <FormattedMessage id="Proposal.Tabs.Options.BrandingColor" />
      </Typography>

      <ColorSwatcher onChange={onUpdatePrimaryColor} selected={selectedColor} />
    </div>
  );
};

export default ProposalCoBrandingColors;
